import React from 'react';
interface LogoProps {
  variant?: 'dark' | 'light';
  className?: string;
}
export function Logo({
  variant = 'dark',
  className = ''
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/fhgQkKHhxHX5BiGUmHUUMy/bonsai-pool-logo.png" alt="Bonsai Pool Care LLC" className={`h-9 md:h-10 w-auto object-contain ${variant === 'light' ? 'brightness-0 invert' : ''} ${className}`} data-id="element-181" />;
}